var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('th'),_c('th'),_c('th'),_c('th'),_c('th',{staticClass:"text-center",attrs:{"colspan":"2"}},[_vm._v("Total Net Price")]),_c('td',{staticClass:"text-center"},[_c('div',[_vm._v("\n      "+_vm._s(_vm.netPrice + " ฿")+"\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }